import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { IgnoreIcon } from '@rsos/assets/icons';
import {
  Box,
  Button,
  FakeLinkComponent,
  Text,
} from '@rsos/components/capstone/base';
import { useSelectedAlert } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import { requestSAML } from '@rsos/sinatra';

/**
 * Sub-component of AlertChatBox that displays remove alert button and supplemental alert information.
 * @param {Function} onRemoveAlertFromQueue - Determine if the alert should be removed from the queue
 */
const RemoveAlert = ({ onRemoveAlertFromQueue }) => {
  const dispatch = useDispatch();

  const currentAlert = useSelectedAlert();

  const isSupplementalOnly = currentAlert?.supplemental_only;

  const handleTrainingLink = () => {
    dispatch(requestSAML('training', 'alerts-training'));
  };

  return (
    <>
      <Button
        btnType="tertiary"
        name="alarm-remove-btn"
        onClick={onRemoveAlertFromQueue}
        size="small"
      >
        <IgnoreIcon width="20px" height="20px" />
        <Text inline size="small">
          Remove from Queue
        </Text>
      </Button>
      {isSupplementalOnly && (
        <Box horizontal justify="center" padding="5px">
          <Text
            color="primaryText"
            fontWeight="bold"
            inline
            marginRight="5px"
            size="small"
            textTransform="uppercase"
          >
            Supplemental Only.
          </Text>
          <FakeLinkComponent
            onClick={handleTrainingLink}
            size="small"
            type="secondary"
          >
            Learn more about Alerts →
          </FakeLinkComponent>
        </Box>
      )}
    </>
  );
};

RemoveAlert.propTypes = {
  onRemoveAlertFromQueue: PropTypes.func.isRequired,
};

export default RemoveAlert;
